import { useQuery } from '@tanstack/react-query'
import { httpClient } from '../api/httpClient'

/**
 * Ambiente Astrea alvo desta instância do viewer — fixo por deploy
 * (`ASTREA_ENVIRONMENT` no `server_app`), não mais uma preferência editável
 * por usuário (ver `server_app/routes/configRouter.js`). Não é dado de
 * sessão: é config de aplicação, igual pra qualquer usuário logado nesta
 * instância, por isso vive em seu próprio hook/query em vez de
 * `AuthContext`. `staleTime`/`gcTime` infinitos porque o valor não muda
 * durante a vida do processo do servidor.
 */
export function useAstreaEnvironment() {
  const query = useQuery({
    queryKey: ['astreaEnvironment'],
    queryFn: async () => {
      const response = await httpClient.get('/config/astrea-environment')
      return response.data
    },
    staleTime: Infinity,
    gcTime: Infinity,
  })

  return {
    urlAstrea: query.data?.urlAstrea,
    urlAstreaPath: query.data?.urlAstreaPath,
    isLoading: query.isLoading,
  }
}

export default useAstreaEnvironment
